import React, { useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg"
import avatar4 from "../../../assets/images/users/avatar-4.jpg"

//i18n
import { withTranslation } from "react-i18next"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon custom-margin-top"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-info rounded-pill pt-1">0</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> Notificaciones </h6>
              </Col>
              <div className="col-auto">
                {/* <a href="#!" className="small">
                  {" "}
                  Ver todo
                </a> */}
              </div>
            </Row>
          </div>

          {/* <SimpleBar style={{ height: "230px" }}>
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-primary rounded-circle font-size-16">
                    <i className="bx bx-cart" />
                  </span>
                </div>
                <div className="media-body">
                  <h6 className="mt-0 mb-1">Completaste curso</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">Curso de impermeabilizantes</p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" /> hace 3 horas
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <img
                  src={avatar3}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="media-body">
                  <h6 className="mt-0 mb-1">Juan González</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">Comentó tu respuesta en el foro.</p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />
                      hace 2 días
                    </p>
                  </div>
                </div>
              </div>
            </Link>
            <Link to="" className="text-reset notification-item">
              <div className="media">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    <i className="bx bx-badge-check" />
                  </span>
                </div>
                <div className="media-body">
                  <h6 className="mt-0 mb-1">Obtuviste insignia</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">Asociado de baños</p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" /> hace 6 días
                    </p>
                  </div>
                </div>
              </div>
            </Link>

            <Link to="" className="text-reset notification-item">
              <div className="media">
                <img
                  src={avatar4}
                  className="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div className="media-body">
                  <h6 className="mt-0 mb-1">Fernanda Ramírez</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      Completó curso de Reparación estructural de concreto.
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" />
                      hace 12 días
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </SimpleBar> */}
          <div className="p-2 border-top d-grid">
            <span className="text-center">Sin notificaciones</span>
          </div>
        </DropdownMenu>
      </Dropdown>
      <style jsx="true">{`
        .custom-margin-top {
          margin-top: 12px;
        }
      `}</style>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any,
}
